import { baseQuery } from '../baseQuery';
import { SkillLevel } from 'types';

type PostTechnicianSkillSetPayload = {
  techId: number;
  skillset_ID: number;
  level: SkillLevel;
};

export const postTechnicianSkillSet = async (payload: PostTechnicianSkillSetPayload) => {
  const { techId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${techId}/skill-sets`, {
    type: 'POST',
    body: {
      ...rest,
    },
  });

  return data;
};
